import { MapPrivacy } from 'features/maps/types'
import { BuilderMode } from '../types'
import { isInIframe } from 'app/utils/embedding'

export function isInBuilderPublicLayout({ builderMode }: { builderMode: BuilderMode }) {
  return builderMode === BuilderMode.Public || (builderMode === BuilderMode.Viewer && isInIframe)
}

export function builderModeToMapPrivacy(builderMode: BuilderMode): MapPrivacy {
  switch (builderMode) {
    case BuilderMode.Editor:
      return MapPrivacy.Private
    case BuilderMode.Viewer:
      return MapPrivacy.Shared
    case BuilderMode.Public:
      return MapPrivacy.Public
  }
}
